<div class="">
    <div class="row">
        <div class="col-md-3 d-flex pt-1">
            <div class="btn-group align-self-center" *ngIf="!showFilterInputs">
                <input #gb (change)="onLazyLoad($event , true)" type="text"  size="30" class="form-control"
                    placeholder="{{ 'FILTER' | translate }}">
            </div>


            <div class="btn-group align-self-center" *ngIf="showFilterInputs" style="margin-left: 10px;">
                <input #gb  type="text" size="30" class="form-control" [(ngModel)]="searchObj.phoneNumber"
                    placeholder="{{ 'MOBILE' | translate }}">
            </div>
            <div class="btn-group align-self-center" *ngIf="showFilterInputs" style="margin-left: 10px;">
                <input #gb  type="text" size="30" class="form-control" [(ngModel)]="searchObj.patCode"
                    placeholder="{{ 'PATCODE' | translate }}">
            </div>

            <div class="btn-group align-self-center" *ngIf="showFilterInputs"  style="margin-left: 10px;">
                <sanabel-selectize appcode="1066" [simpleView]="true" [SearchKeys]="{ScheduledOnly:1}" (clicked)="specialityClicked($event)"  [(ngModel)]="outPatientObj.SpecialityId">
                </sanabel-selectize>
            </div>
            <div class="btn-group align-self-center" *ngIf="showFilterInputs">
                <sanabel-selectize appcode="1052"  [simpleView]="true" #doctorSearch  [(ngModel)]="outPatientObj.DocCode" >
                </sanabel-selectize>
            </div>

            
         


            <!-- <button class="btn btn-primary" title="{{ 'SEARCH' | translate }}" ngbTooltip="search "
                    (click)="getReservationVisits()">
                    <i class="fa fa-search"></i>
                </button> -->
            <!--  </div> -->
              <div style="margin-right: 32px;"  *ngIf="showFilterInputs">
                <i class="fa fa-search" aria-hidden="true" (click)="onSearchClick()" style="font-size: 25px;color: #426d35;padding-top: 4px;cursor: pointer;"></i>
              </div>
              <div style="margin-right: 32px;">
                <i class="fa fa-filter" aria-hidden="true" (click)="onFilterClick()" style="font-size: 25px;color: #45a4f9;padding-top: 4px;cursor: pointer;"></i>
              </div>
              <div style="margin-right: 32px;">
                <i class="fa fa-refresh" aria-hidden="true" (click)="onLazyLoad($event , true)" style="font-size: 25px;color: #45a4f9;padding-top: 4px;cursor: pointer;"></i>
              </div>
        </div>
        <div class="col-md-3">

            <span style="color: blue;">{{ 'TOTALNUMDETICTION' | translate }} :</span>
            <span>{{obj?.totalReservationNum}}</span>
        </div>
        <div style="color: blueviolet;" class="col-md-3 ">

            <span>{{ 'TOTALNOTRESERVATION' | translate }} :</span>
            <span>{{obj?.totalNotReservationNum}}</span>
        </div>
        <!-- <div class="col-xl-3 d-none d-xl-block busy_bed">

            <span>{{'OCCUIPEDBEDSNUM' | translate }} :</span>
            <span>{{obj?.totalPayed}}</span>
        </div> -->
        <div style="color: red;" class=" col-md-3 ">
            <span>{{ 'TOTALCANCELLED' | translate }} :</span>
            <span>{{obj?.totalCancelReservationNum}}</span>
        </div>
    </div>
    <div class="row" *ngIf="showlist">
        <div class="col">
            <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="filteredPatientList" [rows]="10"
                [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]" [totalRecords]="totalRecords"
                [lazy]="true" (onPage)="paginate($event)">
                <p-column field="callerCode" header="{{'CALLERCODE' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'fullnameAr':'fullnameEn'}}"
                    [style]="{'width': '15%'}" header="{{ 'CALLERNAME' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'fullAddressAr':'fullAddressEn'}}"
                    [style]="{'width': '10%'}" header="{{ 'CALLERADDRESS' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'callerStatusAr':'callerStatusEn'}}"
                    [style]="{'width': '10%'}" header="{{ 'CALLERSTATUS' | translate }}"></p-column>
                <p-column field="phoneNumber" [style]="{'width': '10%'}" header="{{ 'MOBILENUMBER' | translate }}">
                </p-column>
                <!-- <p-column field="doctorName" [style]="{'width': '10%'}" header="{{ 'doctorName' | translate }}">
                </p-column> -->
                <p-column [style]="{'width': '10%'}" header="{{ 'doctorName' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div *ngIf="!row['checkNoDoctor']">{{translate.currentLang == 'ar' ?
                            row.docNameAr:row.docNameEn}}</div>

                        <sanabel-selectize [simpleView]="true" appcode="1052" [(ngModel)]="row.doctorName"
                            (clicked)="reservationPatient($event, row)" #doctorSearch
                            [SearchKeys]="{SpecialityId:row['specialization']}" *ngIf="row['checkNoDoctor']">
                        </sanabel-selectize>
                    </ng-template>
                </p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'specializationAr':'specializationEn'}}"
                    [style]="{'width': '8%'}" header="{{ 'specialtyName' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'serviceNameAr':'serviceNameEn'}}"
                    [style]="{'width': '8%'}" header="{{ 'SERVICENAME' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'callReasonNameAr':'callReasonNameEn'}}"
                    [style]="{'width': '10%'}" header="{{ 'CALLREASON' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'callResultNameAr':'callResultNameEn'}}"
                    [style]="{'width': '10%'}" header="{{ 'CALLERRESULT' | translate }}"></p-column>
                <p-column [style]="{'width': '5%'}" header="{{ 'TIME' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <i>
                            {{row['reservationDate'] | date:'"HH:mm"'}}
                        </i>
                    </ng-template>
                </p-column>
                <p-column header="{{ 'CALLDATETIME' | translate }}" [style]="{'width': '10%'}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <i>
                            {{row['regDate'] | date:'short'}}
                        </i>
                    </ng-template>
                </p-column>

                <p-column field="notes" [style]="{'width': '20%'}" header="{{ 'NOTES' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'arrivalCallResultAr':'arrivalCallResultEn'}}"
                    [style]="{'width': '20%'}" header="{{ 'ARRIVERESULT' | translate }}"></p-column>
                <p-column field="{{translate.currentLang == 'ar' ? 'bookedByAr':'bookedByEn'}}"
                    [style]="{'width': '15%'}" header="{{ 'BOOKEDBY' | translate }}"></p-column>

                <p-column width="100" header="{{ 'ACTIONS' | translate }}" [style]="{'width': '5%'}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <span>
                            <icon-action [hidden]="row.arrivalResult==1 ||row.arrivalResult==-1"
                                (actionclicked)="onIconActionClick($event,row)" [appCodes]="[300,6776,305,6960,6958]">
                            </icon-action>
                        </span>

                    </ng-template>
                </p-column>
            </p-dataTable>
        </div>
    </div>
</div>
<div>
    <block-modal-container #popup (close)="onpopupClose($event)">
        <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
    </block-modal-container>
</div>